import React, { use, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import useWindowSize from '@hooks/use-window-size';
import useTimelineQuery from '@hooks/orders-sales/use-timeline-query';
import { scrollTo } from '@helpers/utils/general';
import BackButton from '@components/molecules/web-view-back-button/back-button';
import { TimelineContext } from '@context/timeline.context';
import { mainPageId, hasSelected, getCurrentProduct } from './helper';
import SkeletonView from './product-timeline/skeleton';
import ErrorView from './product-timeline/error';
import TimelineView from './product-timeline/timeline';
import styles from './product-timeline.module.scss';

const ProductTimelineView = () => {
  const { t } = useTranslation('orders-sales');

  const { isWiderThanMd } = useWindowSize();

  const { state, updateState } = use(TimelineContext);

  const currentOrder = state.orderProduct ? state.orderProduct[0] : null;
  const orderId = state.currentTab === 'Order' && currentOrder ? currentOrder.orderId : null;

  const selectedProduct = getCurrentProduct(state);
  const productId = selectedProduct?.productId;

  const { isErrorTimeline, timeline, isLoadingTimeline } = useTimelineQuery(productId, orderId, !!productId);

  useEffect(() => {
    if (timeline && timeline.getPaidNotice && !state.getPaidNotice) {
      updateState({ ...state, getPaidNotice: timeline.getPaidNotice });
    }
  }, [timeline]);

  useEffect(() => {
    scrollTo(`#${mainPageId}`);
  }, [selectedProduct?.productId]);

  if (state.loading || isLoadingTimeline) {
    return (
      <div className={styles.ordersSales__mainRight}>
        <SkeletonView currentTab={state.currentTab} />
      </div>
    );
  }

  if (isErrorTimeline) {
    return (
      <div className={styles.ordersSales__mainRight}>
        <ErrorView
          state={state}
          updateState={updateState}
        />
      </div>
    );
  }

  if (!hasSelected(state) || !selectedProduct || !timeline) {
    const negRight = !isWiderThanMd ? 'ordersSales__mainRight--neg' : '';
    return <div className={clsx(styles.ordersSales__mainRight, styles[negRight])}>{null}</div>;
  }

  return (
    <div className={styles.ordersSales__mainRight}>
      {!isWiderThanMd && (
        <BackButton
          name={t('MY_ACCOUNT.ORDERS_SALES.BACK')}
          onClick={() => updateState({ ...state, orderProduct: null, saleProduct: null })}
          customClassName={styles.ordersSales__mainRight__back}
        />
      )}
      <TimelineView
        order={currentOrder}
        product={selectedProduct}
        timeline={timeline}
      />
    </div>
  );
};

export default ProductTimelineView;
